module.exports = __webpack_public_path__ + "static/home_back3-59301d318136a082f47cef637e4aea69.png";